import { render } from "./ProductenPopup.vue?vue&type=template&id=79459d10&scoped=true"
import script from "./ProductenPopup.vue?vue&type=script&lang=js"
export * from "./ProductenPopup.vue?vue&type=script&lang=js"

import "./ProductenPopup.vue?vue&type=style&index=0&id=79459d10&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\benja\\Desktop\\SKWinkelStarter\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79459d10"]])

export default __exports__